import { render, staticRenderFns } from "./iconFavourite.vue?vue&type=template&id=0ed951a8&scoped=true"
import script from "./iconFavourite.vue?vue&type=script&lang=js"
export * from "./iconFavourite.vue?vue&type=script&lang=js"
import style0 from "./iconFavourite.vue?vue&type=style&index=0&id=0ed951a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed951a8",
  null
  
)

export default component.exports